import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { I_Colors, I_Data } from '../propTypes';
import ItemRow from './ItemRow';
import TableFooter from './TableFooter';
import NotesDefault from '../NotesDefault';

const s = StyleSheet.create({
  container: {
    margin: '0px -40px 0px -40px',
  },
  headerContainer: {
    display: 'flex',
    padding: '0px 30px 0px 30px',
    flexDirection: 'row',
    fontSize: 12,
    fontWeight: 500,
  },
  headerCol: {
    padding: '10px 12px',
  },
  notes: {
    fontSize: 8,
    padding: '0px 40px 0px 40px',
    marginBottom: 16,
    marginTop: 16,
    lineHeight: 1.75,
  },
  title: {
    fontSize: 12,
    fontWeight: 600,
    marginBottom: 4,
  },
});

function ItemsTable({
  data,
  colors,
  layoutNumber,
}: {
  data: I_Data;
  colors: I_Colors;
  layoutNumber: number;
}) {
  return (
    <View style={s.container}>
      {data.type === 'estimate' && data.notes.description ? (
        <View style={s.notes}>
          <Text style={s.title}>Project Description</Text>
          <Text>{data.notes.description}</Text>
        </View>
      ) : null}
      <View
        style={{
          ...s.headerContainer,
          color: colors.color2text,
          backgroundColor: colors.color2,
        }}
      >
        <View
          style={{
            ...s.headerCol,
            width: '60%',
          }}
        >
          <Text>Name</Text>
        </View>
        <View
          style={{
            ...s.headerCol,
            width: '10%',
          }}
        >
          <Text>Qty</Text>
        </View>
        <View
          style={{
            ...s.headerCol,
            width: '15%',
            textAlign: 'right',
          }}
        >
          <Text>Rate</Text>
        </View>
        <View
          style={{
            ...s.headerCol,
            width: '15%',
            textAlign: 'right',
          }}
        >
          <Text>Amount</Text>
        </View>
      </View>
      <View style={{ display: 'flex', flexDirection: 'column' }}>
        {data?.items.map((item) => (
          <ItemRow key={item.item_id} item={item} colors={colors} />
        ))}
        <TableFooter data={data} colors={colors} />
      </View>
      <NotesDefault data={data} layoutNumber={layoutNumber} />
    </View>
  );
}

export default ItemsTable;
